<template>
  <div class="home">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="#">DocSigner</b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-button size="sm" variant="info" to="/documents">
          <img src="img/list.svg" alt="Documents" width="16px">
        </b-button>
      </b-navbar-nav>
    </b-navbar>
    <ShowDocument/>
    <Signature/>
  </div>
</template>

<script>
  import ShowDocument from '../components/ShowDocument'
  import Signature from "../components/Signature";

  export default {
    name: 'Preview',
    components: {
      ShowDocument,
      Signature
    },
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
  .home {
    background-color: aliceblue;
  }
</style>
